<div class="row">
  <div *ngIf="showThumbnails" class="col-3 col-md-2">
    <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
       [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
       [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out" role="link" tabindex="-1">
      <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
      </ds-thumbnail>
    </a>
      <span *ngIf="linkType === linkTypes.None" class="lead item-list-title dont-break-out">
      <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
      </ds-thumbnail>
    </span>
  </div>
  <div [ngClass]="showThumbnails ? 'col-9' : 'col-md-12'">
    <ds-badges *ngIf="showLabel" [object]="dso" [context]="context"></ds-badges>
    <ds-truncatable [id]="dso.id">
      <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
         [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
         [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
         [innerHTML]="dsoTitle" role="link" tabindex="0"></a>
      <span *ngIf="linkType === linkTypes.None"
            class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle"></span>
      <span class="text-muted">
    <ds-truncatable-part [id]="dso.id" [minLines]="1">
            <span *ngIf="dso.allMetadata(['journal.title']).length > 0"
                  class="item-list-journal-volumes">
                    <span *ngFor="let value of allMetadataValues(['journal.title']); let last=last;">
                        <span [innerHTML]="value"></span><span *ngIf="!last">; </span>
                    </span>
            </span>
            <span *ngIf="dso.allMetadata(['publicationvolume.volumeNumber']).length > 0"
                  class="item-list-journal-volume-identifiers">
                    <span *ngFor="let value of allMetadataValues(['publicationvolume.volumeNumber']); let last=last;">
                        <span> (</span><span [innerHTML]="value"></span><span>)</span><span *ngIf="!last">;</span>
                    </span>
            </span>
        </ds-truncatable-part>
  </span>
    </ds-truncatable>
  </div>
</div>
